import React from "react";
import { Link } from "react-router-dom";

// project-imports
import Image from "../../../common/footer/Images/Image";
import ToolTip from "../../../common/Tooltip/ToolTip";
import { GoogleAnalyticsEnum, triggerFunction } from "../../../utils/google-analytics";


function VideoContentWidget({ data, classes, onOpenDrawer, onVideoToggle }) {

    // constants variables
    const videoTitle = (data && data?.cleanTitle) || "";
    const videoViews = (data && data?.viewdCount) || 0;
    const videoThumbnail = (data && data?.featuredImage) || "";

    return (
        <div>
            <div class={`edu-blog-widget-2 widget-latest-post ${classes ? classes : ""}`}>
                <div class="inner">
                    <div class="content latest-post-list">
                        <div class="latest-post">
                            <div class="thumbnail">
                                <div class="d-block related-series-image clickable">
                                    <Image src={videoThumbnail} alt="Thumbnail" onClick={() => { onVideoToggle(data?.videoUrl); triggerFunction(window.location.href + GoogleAnalyticsEnum.LSA_SALESFORCE_TUTORIALS_VIDEO_PLAYED_BUTTON_CLICKED, data?.cleanTitle); }} fill />
                                </div>
                            </div>
                            <div class="post-content">
                                <ToolTip title={videoTitle}>
                                    <h6 class="title truncate-2-lines fs-17 text-start">
                                        <Link class="d-block"
                                            onClick={() => onOpenDrawer(data)}
                                        >
                                            {videoTitle}
                                        </Link>
                                    </h6>
                                </ToolTip>
                                <ul class="blog-meta">
                                    <li className="fs-14">{videoViews} Views</li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default VideoContentWidget;
